﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VControllerViewContract = exports.VControllerViewResult = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const VControllerViewABI_1 = require("./abi/VControllerViewABI");
class VControllerViewResult {
}
exports.VControllerViewResult = VControllerViewResult;
class VControllerViewContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, VControllerViewABI_1.VControllerViewABI.GetABI());
    }
    getVXRateAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("countView");
            if (!result)
                return;
            result.vxRatio = this._toDecimal(result.vxRatio);
            result.contedBalance = this._toDecimal(result.contedBalance);
            result.apr = this._toDecimal(result.apr);
            return result;
        });
    }
    getCountedBalanceAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const balance = yield this._call("countedBalance");
            return this._toDecimal(balance);
        });
    }
    getValidatorsCountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const validatorsCount = yield this._call("validatorsCount");
            return validatorsCount;
        });
    }
    getValidatorsToExitAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const validatorsCount = yield this._call("validatorsToExit");
            return validatorsCount;
        });
    }
    getVXAddressAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this._call("vx");
            return address;
        });
    }
    getVPoolAddressAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this._call("vpool");
            return address;
        });
    }
    getValidatorGas() {
        return __awaiter(this, void 0, void 0, function* () {
            const gas = yield this._call("validatorGas");
            return this._toDecimal(gas);
        });
    }
}
exports.VControllerViewContract = VControllerViewContract;
//# sourceMappingURL=VControllerViewContract.js.map